var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1458 7.24689L13.2408 1.3419C11.4496 -0.444696 8.55038 -0.444696 6.75918 1.3419L0.854189 7.24689C0.30544 7.79271 -0.00213725 8.53536 1.11799e-05 9.30939V17.9577C0.00184711 19.0866 0.917002 20.0009 2.04587 20.0019H17.9542C19.083 20.001 19.9981 19.0866 20 17.9577V9.30939C20.0022 8.53536 19.6946 7.79271 19.1458 7.24689ZM17.5 17.5019H13.3333V14.8502C13.3333 13.093 11.9089 11.6685 10.1517 11.6685H9.84835C8.09117 11.6685 6.66668 13.093 6.66668 14.8502V17.5019H2.50001V9.30939C2.50028 9.19888 2.54395 9.09294 2.62169 9.01439L8.52667 3.1094C9.34015 2.29569 10.6592 2.29553 11.473 3.10901C11.4731 3.10912 11.4732 3.10928 11.4733 3.1094L17.3783 9.01439C17.456 9.09294 17.4997 9.19888 17.5 9.30939V17.5019H17.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.5245d51d3d2c535888558034dc48d746.svg";
export { ForwardRef as ReactComponent };